module.exports = __webpack_public_path__ + "img/IMG-20190918-WA0011.c29fca7a.jpg";